
import { MARKETPLACE_CODE_PRINT_ON_DEMAND, MARKETPLACE_CODE_READY_TO_SELL } from 'shared/constants/marketplace'

import { ProductCarouselStore } from 'retailer/stores'

class DashboardStore {
  /** @type {import('../context').RootStore} */
  root

  constructor (root) {
    this.root = root
    this.podCarouselStore = new ProductCarouselStore(this.root, {
      marketplaceCode: MARKETPLACE_CODE_PRINT_ON_DEMAND,
      ordering: '-created',
    })
    this.rtsCarouselStore = new ProductCarouselStore(this.root, {
      marketplaceCode: MARKETPLACE_CODE_READY_TO_SELL,
      ordering: '-created',
    })
  }
}

export default DashboardStore
